import CardVM from './../card/card-vm';

export default function(data) {
  this.$el = $('#my_courses');
  this.courses = ko.observableArray();
  this.showingSearchResults = ko.observable(false);

  this.filters = {
    active(course) {
      return (
        course.is_active() ||
          course.is_upcoming() ||
            course.is_pending()
      ) &&
        !(course.is_ended() || (course.current_user && course.current_user.is_archived()));
    },

    upcoming(course) {
      return course.is_upcoming() || course.is_pending();
    },

    archived(course) {
      if (course.current_user) {
        return course.is_ended() || course.current_user.is_archived();
      } else {
        return course.is_ended();
      }
    },

    draft(course) {
      return course.is_draft() || course.is_cloning() || course.is_denied();
    },

    notProgram(course) {
      return !(course.current_user && course.current_user.is_program());
    },

    program(course) {
      return course.current_user && course.current_user.is_program();
    },

    all(course) {
      return course;
    }
  };

  this.currentFilter = ko.observable(this.filters['active']);
  this.currentFilterName = ko.observable('active');
  this.searchQuery = ko.observable();
  this.shareEmails = ko.observable();

  this.bindData = data => {
    const mapping = {
      courses: {
        create(options) {
          return new CardVM(options.data, this);
        }
      }
    };

    const mappedCourses = ko.mapping.fromJS(data, mapping);

    if (typeof mappedCourses.courses === 'function')
      this.courses(mappedCourses.courses())

    this.filtered_courses = ko.computed(() => {
      if (this.currentFilter()) {
        return ko.utils.arrayFilter(this.courses(), this.currentFilter());
      } else {
        return this.courses();
      }
    });

    this.non_program_courses = ko.computed(() => {
      return ko.utils.arrayFilter(this.filtered_courses(), this.filters['notProgram']);
    });

    this.course_programs = ko.computed(() => {
      const programs = {};

      const courses = ko.utils.arrayFilter(this.filtered_courses(), this.filters['program']);

      courses.forEach(course => {
        const name = course.current_user.program_name();
        programs[name] = programs[name] || [];
        programs[name].push(course);
      });

      return programs;
    });
  };

  this.initUI = () => {
    document.addEventListener('click', this.hideOptionsMenu);

    $('#courseSearch').on('keypress', event => {
      const keycode = (event.keyCode ? event.keyCode : event.which);

      if (keycode == '13') {
        $('#courseSearch').blur();
        this.filterChanged();
      }
    });

    //
    // tells screenreader if programs area toggle button is collapsed or expanded
    //
    $('body').on('shown.bs.collapse', '.program-group__grid', () => {
      $('.program-group__divide_btn').attr('aria-expanded', 'true');
    });

    $('body').on('hidden.bs.collapse', '.program-group__grid', () => {
      $('.program-group__divide_btn').attr('aria-expanded', 'false');
    });

    Kadenze.UIUtil.initDotDotDotTruncation();
    Kadenze.UIUtil.initLazyImageLoading();
  };

  this.showCourse = element => {
    if (element.nodeType === 1) {
      $(element).hide().fadeIn();

      $(element).find('.js-dotdotdot').dotdotdot({ watch : 'window' });
    }
  };

  this.hideCourse = element => {
    if (element.nodeType === 1)
      $(element).fadeOut();
  };

  this.leaveCourse = (item, event) => {
    const $card = $(`#course-${item.id()}`);

    this.confirmAction(
      $card,
      `${item.number()}: ${item.name()}`,
      'Are you sure you want to leave the course ',
      () => {
        const url = item.current_user.unenroll_path();
        const method = 'DELETE';

        Kadenze.Analytics.track(
          'course',
          item.restricted() ? 'cancel_enrollment_request' : 'withdrawn',
          {
            course: {
              id: item.id(),
              number: item.number(),
              name: item.name()
            }
          }
        );

        Kadenze.UIUtil.makeRequest(
          url,
          method,
          null,
          this.$el,
          null,
          (data, textStatus, xhr) => {
            this.courses.remove(item);

            Kadenze.Analytics.track(
              'course',
              'withdrawn',
              {
                course: {
                  id: item.id(),
                  number: item.number(),
                  name: item.name()
                }
              }
            );

            new Kadenze.Notice.success(data);
          },
          (xhr, textStatus, errorThrown) => new Kadenze.Notice.error(xhr.responseJSON)
        );
      },
      () => { }
    );

    this.hideOptionsMenu($card);

    event.stopPropagation();
  };

  this.hideOptionsMenu = $card => {
    $('.js-course-card-options-menu', $card).hide();
  };

  this.confirmAction = ($card, title, prompt, confirmed, cancelled) => {
    const $holder = $card.find('.js-confirmation');
    const $prompt = $(
      JST['templates/card-confirmation']({
        title: title,
        body: prompt,
        cancel_btn_text: 'No',
        ok_btn_text: 'Yes'
      })
    );

    $holder.html($prompt);

    $prompt.find('.btn--del').on('click', () => {
      $prompt.hide();

      if (typeof cancelled == 'function')
        cancelled();
    });

    $prompt.find('.btn--prim').on('click', () => {
      $prompt.hide();

      if (typeof confirmed == 'function')
        confirmed();
    });

    $prompt.show();
  };

  this.setFilter = type => {
    this.currentFilter(this.filters[type]);
    //
    // Can't read name of currentFilter function in minified environment so just set it explicitly
    //
    this.currentFilterName(type);
    Kadenze.UIUtil.initLazyImageLoading();
  };

  this.courseListing = (url, params) => {
    //
    //load the entries info from the server
    //
    url = url ? url : Kadenze.Routes.my_courses_path(params);

    const request = new Kadenze.AjaxRequest({
      type: 'GET',
      url: url,
      dataAsJSON: false,
      data: params,
      loadingIndicator: {
        container: this.$el
      }
    });

    request.done(data => {
      this.showingSearchResults(!_.isEmpty(this.searchQuery()));
      this.bindData(data);
    });

    request.error(data => {
      new Kadenze.Notice.error({ message: I18n.t('notice.unexpected_error') });
    });

    request.always(data => Kadenze.UIUtil.initLazyImageLoading())

    return request;
  };

  this.filterChanged = () => {
    this.courseListing(null, { q: this.searchQuery() });
  };

  this.clearSearch = () => {
    this.searchQuery('');

    this.courseListing().then(() => this.showingSearchResults(false))
  };

  (() => this.bindData(data))()
}
